import { render, staticRenderFns } from "./ProductConsumptions.vue?vue&type=template&id=d0add1aa&"
import script from "./ProductConsumptions.vue?vue&type=script&lang=js&"
export * from "./ProductConsumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports